import axios from '../../../axios';
import IVendorLists from '../types/IVendorLists';
const url = '/vendorsearch/api/';
export const indexVendorLists = (vendorLists: IVendorLists) =>
  axios.post(`${url}vendorlists`, vendorLists);
